import { Controller } from '@hotwired/stimulus';

export default class FormatSelectController extends Controller {
  changed() {
    this.dispatch('changed');
  }
}
